import { Box, ListItemButton, ListItemIcon, Tooltip, Typography } from "@mui/material";
import { MetaIcons } from "../../../../../../../../api/types/svTypes";
import type { ReportField } from "../../../../../../../../api/types/svTypes.ts";
import type { DrillDownLayer } from "../../../../store/types/drillDownPageState.types";
import MetaIcon from "../../../common/MetaIcon";

interface ItemProps {
  component: DrillDownLayer;
  field?: ReportField;
  index: number;
  active: boolean;
  onSelect: (index: number) => void;
}

const unavailableDrillDownTooltip = "This parameter has no drilldown data.";

const DrillDownComponentItem = ({ component, field, index, active, onSelect }: ItemProps) => {
  const disabled = component.disabled === true;
  const content = (
    <ListItemButton
      selected={active}
      disabled={disabled}
      onClick={() => onSelect(index)}
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        borderRadius: "2px",
        py: 0.5,
        px: 2,
        minHeight: 34,
        color: disabled
          ? theme.palette.text.disabled
          : active
            ? theme.palette.primary.main
            : theme.palette.text.secondary,
        opacity: disabled ? 1 : undefined,
      })}
    >
      <ListItemIcon sx={{ color: "inherit", minWidth: "20px", justifyContent: "center" }}>
        {component.functionName === "GrandTotal" ? (
          <MetaIcon icon={MetaIcons.Function} />
        ) : (
          <MetaIcon icon={field?.meta.icon ?? MetaIcons.Sigma} />
        )}
      </ListItemIcon>
      <Typography noWrap sx={{ color: "inherit" }}>
        {getDisplayName(component.functionName, field)}
      </Typography>
    </ListItemButton>
  );

  if (!disabled) {
    return content;
  }

  return (
    <Tooltip title={unavailableDrillDownTooltip} arrow disableInteractive>
      <Box sx={{ width: "100%" }}>{content}</Box>
    </Tooltip>
  );
};

export default DrillDownComponentItem;

function getDisplayName(functionName: string | undefined, field: ReportField | undefined): string {
  const caption = field?.config.customLabel || field?.meta.caption || "";
  return functionName ? `${functionName}(${caption})` : caption;
}
